import React from 'react';
import CodeSnippet from './CodeSnippet';
import {
  DocContainer,
  Title,
  SubTitle,
  Paragraph,
  List,
  ListItem,
} from './DocStyles';

const IntroducaoDoc: React.FC = () => {
  return (
    <DocContainer>
      <Title>Introdução ao SmartEntrega</Title>

      <Paragraph>
        O SmartEntrega é uma aplicação web desenvolvida para gerenciar usuários
        do app de Smart Entregas. Este documento fornece uma visão geral do
        projeto e serve como guia para desenvolvedores que estão começando a
        trabalhar com o código.
      </Paragraph>

      <SubTitle>Visão Geral</SubTitle>
      <Paragraph>
        O SmartEntrega é construído utilizando as seguintes tecnologias
        principais:
      </Paragraph>
      <List>
        <ListItem>
          <strong>React</strong>: Biblioteca JavaScript para construção de
          interfaces de usuário
        </ListItem>
        <ListItem>
          <strong>TypeScript</strong>: Superset de JavaScript que adiciona
          tipagem estática
        </ListItem>
        <ListItem>
          <strong>Redux</strong>: Biblioteca para gerenciamento de estado da
          aplicação
        </ListItem>
        <ListItem>
          <strong>React Router</strong>: Biblioteca para gerenciamento de rotas
        </ListItem>
        <ListItem>
          <strong>Styled Components</strong>: Biblioteca para estilização de
          componentes
        </ListItem>
      </List>

      <SubTitle>Funcionalidades Principais</SubTitle>
      <List>
        <ListItem>Autenticação de usuários (login/logout)</ListItem>
        <ListItem>Dashboard para visualização de dados</ListItem>
        <ListItem>Cadastro de usuários</ListItem>
        <ListItem>Geração de relatórios</ListItem>
        <ListItem>Documentação do sistema</ListItem>
      </List>

      <SubTitle>Requisitos do Sistema</SubTitle>
      <Paragraph>
        Para trabalhar com o projeto, você precisará ter instalado:
      </Paragraph>
      <List>
        <ListItem>Node.js (versão 20 ou superior)</ListItem>
        <ListItem>npm ou yarn</ListItem>
        <ListItem>Git</ListItem>
      </List>

      <SubTitle>Como Iniciar o Projeto</SubTitle>
      <ol>
        <li>
          <Paragraph>Clone o repositório:</Paragraph>
          <CodeSnippet code="git clone [URL_DO_REPOSITÓRIO]" />
        </li>
        <li>
          <Paragraph>Navegue até a pasta do projeto:</Paragraph>
          <CodeSnippet code="cd smartentrega-web/entregas" />
        </li>
        <li>
          <Paragraph>Instale as dependências:</Paragraph>
          <CodeSnippet
            code="npm install
# ou
yarn install"
          />
        </li>
        <li>
          <Paragraph>Inicie o servidor de desenvolvimento:</Paragraph>
          <CodeSnippet
            code="npm start
# ou
yarn start"
          />
        </li>
        <li>
          <Paragraph>Acesse a aplicação em seu navegador:</Paragraph>
          <CodeSnippet code="http://localhost:3000" />
        </li>
      </ol>

      <SubTitle>Estrutura do Projeto</SubTitle>
      <Paragraph>
        A aplicação segue uma estrutura organizada de pastas que será detalhada
        no próximo documento. Esta estrutura facilita a manutenção e
        escalabilidade do código.
      </Paragraph>
    </DocContainer>
  );
};

export default IntroducaoDoc;
